import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import AuthToken from '../../utils/AuthToken';
import { API_URL } from '../../constants';
import { formatCurrency } from '../../utils/appUtils';
import { useTokens } from '../../context/TokenContext';

const OrderTable = ({ userToken }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_URL}/dashboard/latest-orders`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken || adminAuthToken}`,
        },
      });
      setOrders(data || []);
    } catch (error) {
      toast.error('Failed to fetch orders');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const renderStatusBadge = (status) => {
    const statusMap = {
      completed: 'success',
      pending: 'warning',
      processing: 'info',
      cancelled: 'danger',
    };

    return (
      <span className={`badge bg-${statusMap[status?.toLowerCase()] || 'secondary'}`}>
        {status?.charAt(0).toUpperCase() + status?.slice(1)}
      </span>
    );
  };

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fs-6 mb-0">Latest Orders</h4>
        <a href="/admin/order" className="btn btn-sm btn-outline-primary">
          View All
        </a>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>Order ID</th>
              <th>Vendor</th>
              <th>Customer</th>
              <th>Total (₹)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order) => (
                <tr key={order.orderId}>
                  <td>{order.orderId}</td>
                  <td>{order.vendor.store_name || '—'}</td>
                  <td>{order.customer.name || '—'}</td>
                  <td>{formatCurrency(order.totalPrice)}</td>
                  <td>{renderStatusBadge(order.order_status	)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">No recent orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderTable;
